__turbopack_context__.v({
  "inline": "SignupButton-module-scss-module__nAL5tW__inline",
  "signup": "SignupButton-module-scss-module__nAL5tW__signup",
});
